










import { getAdminPermition } from "@/services/accessDecoder";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class ButtonHistory extends Vue {
  get rule(): boolean {
    const root = this.$getRootPermition();
    if (root) return true;
    return getAdminPermition();
  }
}
